import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../utils/cn';
import { PageBreadcrumb } from './page-breadcrumb';
/**
 * ContentWrapper - A simple wrapper for page content without any chrome (header/sidebar)
 * This replaces PageLayout and is meant to be used inside the app shell
 */
export function ContentWrapper({ children, className, noPadding = false, fullHeight = true, breadcrumbs, allowScroll = false }) {
    return (_jsx("div", { className: cn('content-wrapper', fullHeight && 'flex-1 h-full', 'flex flex-col', allowScroll ? 'overflow-auto' : 'overflow-hidden', className), children: _jsxs("div", { className: cn('flex-1', !allowScroll && 'overflow-hidden', // Changed from overflow-auto to overflow-hidden
            !allowScroll && 'flex flex-col', // Added flex column for proper height distribution
            !noPadding && 'pt-3 pr-3 pb-6 pl-3', 'relative'), children: [breadcrumbs && breadcrumbs.length > 0 && (_jsx(PageBreadcrumb, { items: breadcrumbs, className: "flex-shrink-0 pl-3 pt-2 pb-1" })), children] }) }));
}
ContentWrapper.displayName = 'ContentWrapper';
